// Global market sentiment (-1..1): slow mean-reverting random walk with regime shifts.

import { TUNABLES } from "@degen/shared/config/tunables";
import type { Rng } from "../rng";

export type Regime = "normal" | "bull" | "crash";

export interface Sentiment {
  value: number;
  regime: Regime;
  regimeUntilDay: number;
}

const S = TUNABLES.market.sentiment;

export function createSentiment(): Sentiment {
  return { value: 0, regime: "normal", regimeUntilDay: 0 };
}

export function stepSentiment(s: Sentiment, rng: Rng) {
  const target = S.targets[s.regime];
  s.value += (target - s.value) * S.meanReversion + rng.normal() * S.volatility;
  s.value = Math.max(-1, Math.min(1, s.value));
}

/** Returns the new regime when a shift starts, otherwise null. */
export function sentimentNewDay(s: Sentiment, day: number, rng: Rng): Regime | null {
  if (s.regime !== "normal") {
    if (day >= s.regimeUntilDay) s.regime = "normal";
    return null;
  }
  if (!rng.chance(S.regimeShiftChancePerDay)) return null;
  s.regime = rng.chance(S.bullShare) ? "bull" : "crash";
  s.regimeUntilDay = day + rng.int(S.regimeDays[0], S.regimeDays[1]);
  return s.regime;
}

/** Multiplier applied to NPC buy probability. */
export function sentimentBuyMultiplier(s: Sentiment): number {
  return Math.max(0.1, 1 + s.value * S.buyMultiplier);
}
